angular.module('charts')
  .directive("timeframeLabel", function() {
    return {
      restrict: "E",
      scope: {
      },
      templateUrl: '/resources/charts/partials/timeframe-label.html',
      controller: ['$scope', '$rootScope', 'moment', function($scope, $rootScope, $moment) {
          var normalizeFormat = 'YYYY-MM-DD';
          var format = 'LL';

          $rootScope.$watch('reportDates', function(newValue) {
            if (newValue) {
              $scope.reportDates = newValue;
              $scope.fromDate = $moment(newValue.from_date, normalizeFormat).format(format);
              $scope.toDate = $moment(newValue.to_date, normalizeFormat).format(format);
              $scope.label = $scope.fromDate + ' - ' + $scope.toDate;
            } else {
              $scope.label = '';
            }
          });
      }]
    };
  });
